import {useState} from 'react'
import {Modal, Button, Form} from 'react-bootstrap'
import {useMutation} from '@apollo/client'
import {toast} from 'react-toastify'

import {CREATE_KANBAN_STAGE} from '../../../gql/mutations/kanban'
import {ICreateKanbanStageRes} from '../../../types/kanban'

interface Props {
  show: boolean
  workflowId: string
  onClose: () => void
  onCreated: () => void
}

const DEFAULT_COLOR = ''

export const ModalCreateKanbanStage: React.FC<Props> = ({show, workflowId, onClose, onCreated}) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [isClosedState, setIsClosedState] = useState(false)
  const [color, setColor] = useState(DEFAULT_COLOR)

  const [createStage, {loading}] = useMutation<ICreateKanbanStageRes>(CREATE_KANBAN_STAGE)

  const handleClose = () => {
    if (loading) return
    setName('')
    setDescription('')
    setIsClosedState(false)
    setColor(DEFAULT_COLOR)
    onClose()
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (!workflowId) {
      toast.error('Selecciona un flujo antes de crear una columna')
      return
    }

    try {
      const {data} = await createStage({
        variables: {
          workflowId,
          name,
          description: description || null,
          color: color || null,
          isClosedState,
        },
      })
      if (!data?.createKanbanStage?.ok) {
        toast.error('No se pudo crear la etapa.')
        return
      }
      toast.success('Etapa creada correctamente')
      handleClose()
      onCreated()
    } catch (error) {
      console.error(error)
      toast.error('Error creando la etapa')
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered className='kanban-stage-modal'>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton className='kanban-stage-modal__header'>
          <Modal.Title>New Column</Modal.Title>
        </Modal.Header>
        <Modal.Body className='kanban-stage-modal__body'>
          <Form.Group className='kanban-stage-modal__group'>
            <Form.Label>Name</Form.Label>
            <Form.Control
              className='kanban-stage-modal__input'
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder='Ej. En progreso'
              required
            />
          </Form.Group>
          <Form.Group className='kanban-stage-modal__group'>
            <Form.Label>Description</Form.Label>
            <Form.Control
              className='kanban-stage-modal__input'
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder='Opcional'
            />
          </Form.Group>
          <Form.Group className='kanban-stage-modal__group'>
            <Form.Label>Color</Form.Label>
            <div className='kanban-color-picker'>
              <Form.Control
                className='kanban-stage-modal__input kanban-stage-modal__input--color'
                type='color'
                value={color || '#ffffff'}
                onChange={(e) => setColor(e.target.value)}
                title='Selecciona un color'
              />
              <Button variant='link' size='sm' onClick={() => setColor(DEFAULT_COLOR)}>
                No color
              </Button>
            </div>
          </Form.Group>
          <Form.Check
            className='kanban-stage-modal__checkbox'
            type='switch'
            id='kanban-stage-closed'
            label='Marca como etapa de cierre'
            checked={isClosedState}
            onChange={(e) => setIsClosedState(e.target.checked)}
          />
        </Modal.Body>
        <Modal.Footer className='kanban-stage-modal__footer'>
          <Button variant='light' onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant='primary' type='submit' disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}
